export enum ErrorCode {
  InvalidPaymentCard = 5000,
  ExpiredPaymentCard = 5001,
  CouldNotOpenWebview = 5002,
  InvalidLocationBarcode = 5003,
  InvalidProductBarcode = 5004,
  NoPriceForProduct = 5005,
  NoCustomerGroups = 5006,
  NoTaxRateShifts = 5007,
  NoTaxrates = 5008,
  NoPayments = 5009,
  NoModifiers = 5010,
  NoPriceLevels = 5011,
  CouldNotGetPurchaseHistory = 5012,
  CouldNotGetTransactionReceipt = 5013,
}
